import { useCallback } from 'react';
import {
  approveKnowledgeSource,
  promoteTicketToKnowledge,
  setIntegrityDisposition,
  submitSupportFeedback,
} from '../services/help/supportFeedback';

export function useSupportLearning() {
  const submitFeedback = useCallback(
    (input: Parameters<typeof submitSupportFeedback>[0]) => submitSupportFeedback(input),
    [],
  );
  const promoteTicket = useCallback(
    (input: Parameters<typeof promoteTicketToKnowledge>[0]) => promoteTicketToKnowledge(input),
    [],
  );
  const approveSource = useCallback(
    (input: Parameters<typeof approveKnowledgeSource>[0]) => approveKnowledgeSource(input),
    [],
  );
  const setDisposition = useCallback(
    (input: Parameters<typeof setIntegrityDisposition>[0]) => setIntegrityDisposition(input),
    [],
  );

  return { submitFeedback, promoteTicket, approveSource, setDisposition };
}
